import { TranslationKeys } from "./en";

export const es: TranslationKeys = {
  common: {
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    confirm: "Confirmar",
    back: "Atrás",
    next: "Siguiente",
    done: "Hecho",
    search: "Buscar",
    noResults: "No se encontraron resultados",
    viewAll: "Ver todo",
    seeMore: "Ver más",
    close: "Cerrar",
    retry: "Reintentar",
    share: "Compartir",
    copy: "Copiar",
    signOut: "Cerrar sesión",
    or: "o",
    and: "y",
    yes: "Sí",
    no: "No",
    optional: "Opcional",
    required: "Requerido",
    submit: "Enviar",
    update: "Actualizar",
    create: "Crear",
    add: "Añadir",
    remove: "Eliminar",
    filter: "Filtrar",
    sort: "Ordenar",
    all: "Todos",
    none: "Ninguno",
    select: "Seleccionar",
    selected: "seleccionado",
    showing: "Mostrando",
    of: "de",
    to: "a",
    from: "desde",
  },
  nav: {
    dashboard: "Panel",
    feed: "Inicio",
    workout: "Entrenamiento",
    templates: "Plantillas",
    leaderboard: "Clasificación",
    analytics: "Estadísticas",
    achievements: "Logros",
    premium: "Premium",
    friends: "Amigos",
    profile: "Perfil",
    notifications: "Notificaciones",
    settings: "Configuración",
    support: "Soporte",
    logout: "Cerrar sesión",
    more: "Más",
    newWorkout: "Nuevo entrenamiento",
    home: "Inicio",
    admin: "Admin",
  },
  auth: {
    welcome: "Bienvenido",
    signIn: "Iniciar sesión",
    signUp: "Registrarse",
    signInDescription: "Inicia sesión en tu cuenta",
    signUpDescription: "Crea una nueva cuenta para comenzar",
    signInOrCreateAccount: "Inicia sesión o crea una cuenta",
    email: "Correo electrónico",
    password: "Contraseña",
    username: "Nombre de usuario",
    usernamePlaceholder: "Elige un nombre de usuario",
    passwordPlaceholder: "Ingresa tu contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    resetPassword: "Restablecer contraseña",
    resetPasswordDesc: "Ingresa tu correo para recibir un enlace de restablecimiento",
    resetPasswordDescription: "Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.",
    sendResetLink: "Enviar enlace",
    setNewPassword: "Establecer nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    confirmNewPassword: "Confirmar nueva contraseña",
    confirmNewPasswordBtn: "Confirmar contraseña",
    confirmYourPassword: "Confirma tu contraseña",
    newPassword: "Nueva contraseña",
    enterNewPassword: "Ingresa nueva contraseña",
    enterNewPasswordBelow: "Ingresa tu nueva contraseña abajo",
    createAccount: "Crear cuenta",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    dontHaveAccount: "¿No tienes una cuenta?",
    signingIn: "Iniciando sesión...",
    creatingAccount: "Creando cuenta...",
    sending: "Enviando...",
    updating: "Actualizando...",
    passwordRequirements: "Debe contener al menos 12 caracteres, incluyendo mayúsculas, minúsculas, números y caracteres especiales",
    passwordHint: "Debe incluir mayúsculas, minúsculas, números y caracteres especiales",
    emailVerified: "¡Correo verificado!",
    emailVerifiedDesc: "Ahora puedes iniciar sesión con tus credenciales",
    checkEmail: "Revisa tu correo para el enlace de verificación",
    checkYourEmail: "Revisa tu correo",
    resetLinkSent: "Enlace de restablecimiento enviado",
    failedToSendReset: "No se pudo enviar el enlace de restablecimiento",
    accountCreated: "¡Cuenta creada!",
    welcomeMessage: "¡Bienvenido a FITLINK! Empecemos.",
    welcomeToFitlink: "Bienvenido a FITLINK",
    loginFailed: "Error de inicio de sesión",
    signupFailed: "Error de registro",
    usernameTaken: "Este nombre de usuario ya está en uso",
    passwordsDontMatch: "Las contraseñas no coinciden",
    passwordsDontMatchDesc: "Por favor asegúrate de que ambas contraseñas coincidan",
    passwordUpdated: "¡Contraseña actualizada!",
    passwordUpdatedDesc: "Tu contraseña ha sido actualizada exitosamente",
    passwordRequirementsNotMet: "La contraseña no cumple los requisitos",
    missingCredentials: "Credenciales faltantes",
    enterEmail: "Por favor ingresa tu correo electrónico",
    enterPassword: "Por favor ingresa tu contraseña",
    accountLocked: "Cuenta bloqueada",
    tooManyAttempts: "Demasiados intentos. Por favor intenta más tarde.",
    tryAgainLater: "Por favor intenta más tarde",
    serviceUnavailable: "Servicio no disponible",
    serviceUnavailableDesc: "Por favor intenta de nuevo en unos minutos",
    privacyNotice: "Aviso de privacidad",
    privacyDescription: "Recopilamos tus datos de entrenamiento para proporcionar recomendaciones personalizadas de fitness.",
    dataCollection: "Datos que recopilamos",
    dataPrivacy: "Privacidad de datos",
    dataPrivacyDesc: "Tus datos están encriptados y nunca se venden a terceros",
    agreeToTerms: "Al registrarte, aceptas nuestros",
    termsAndPrivacy: "Términos de servicio y Política de privacidad",
    termsOfUse: "Términos de uso",
    privacyPolicy: "Política de privacidad",
    stayFitStayLinked: "Mantente en forma, mantente conectado.",
    tagline: "Tu compañero personal de fitness",
    verificationEmailSent: "Te hemos enviado un correo de verificación. Por favor revisa tu bandeja de entrada y haz clic en el enlace para verificar tu cuenta.",
    fullName: "Nombre completo",
  },
  settings: {
    title: "Configuración",
    description: "Gestiona tus preferencias y datos de la app",
    appearance: "Apariencia",
    darkMode: "Modo oscuro",
    lightMode: "Modo claro",
    themeDescription: "Alternar entre tema claro y oscuro",
    language: "Idioma",
    languageDescription: "Elige tu idioma preferido",
    saveReload: "Guardar y recargar",
    profileManagement: "Gestión de perfil",
    personalInfo: "Información personal",
    personalInfoDescription: "Actualiza tus datos para recomendaciones de IA",
    editPersonalInfo: "Editar información personal",
    goalsExperience: "Objetivos y experiencia",
    goalsDescription: "Actualiza tus objetivos de fitness y nivel de experiencia",
    updateGoals: "Actualizar objetivos",
    subscription: "Suscripción",
    manageSubscription: "Gestionar suscripción",
    updatePayment: "Actualizar pago o cancelar plan",
    legalPrivacy: "Legal y privacidad",
    legalDescription: "Revisa nuestras políticas y términos",
    termsOfUse: "Términos de uso",
    privacyPolicy: "Política de privacidad",
    dangerZone: "Zona de peligro",
    dangerDescription: "Elimina permanentemente todos tus datos de entrenamiento, PRs, logros y estadísticas",
    resetStatistics: "Restablecer todas las estadísticas",
    deleteAccount: "Eliminar cuenta",
    resetConfirmTitle: "¿Restablecer todas las estadísticas?",
    resetConfirmDescription: "Esta acción no se puede deshacer. Esto eliminará permanentemente:",
    resetConfirmList: {
      workouts: "Todo tu historial de entrenamientos",
      exercises: "Todos los registros de ejercicios",
      prs: "Todos los récords personales (PRs)",
      achievements: "Todos los logros e insignias",
      streaks: "Todas las rachas de entrenamiento",
    },
    resetConfirmWarning: "¿Estás absolutamente seguro de que quieres continuar?",
    resetButton: "Sí, restablecer todo",
    resetting: "Restableciendo...",
    deleteConfirmTitle: "¿Eliminar cuenta permanentemente?",
    deleteWarning: "¡Esta acción es PERMANENTE y NO se puede deshacer!",
    deleteConfirmList: {
      workouts: "Todos los entrenamientos e historial de ejercicios",
      achievements: "Todos los logros y récords personales",
      friends: "Todos los amigos y conexiones sociales",
      photos: "Todas las fotos y datos de check-in",
      profile: "Tu perfil e información de cuenta",
      subscription: "Tu suscripción (si está activa)",
    },
    typeDelete: "Escribe DELETE para confirmar:",
    deleting: "Eliminando...",
    deleteButton: "Eliminar cuenta permanentemente",
  },
  toast: {
    saved: "Cambios guardados correctamente",
    deleted: "Eliminado correctamente",
    error: "Algo salió mal",
    copied: "Copiado al portapapeles",
    signedOut: "Sesión cerrada correctamente",
    workoutDeleted: "Entrenamiento eliminado",
    workoutSaved: "Entrenamiento guardado correctamente",
    templateSaved: "¡Plantilla guardada!",
    templateDeleted: "Plantilla eliminada",
    preferencesUpdated: "Preferencias actualizadas",
    friendRequestSent: "Solicitud de amistad enviada",
    friendRequestAccepted: "¡Solicitud de amistad aceptada!",
    profileUpdated: "Perfil actualizado correctamente",
  },
  workout: {
    title: "Entrenamiento",
    startWorkout: "Iniciar entrenamiento",
    finishWorkout: "Finalizar entrenamiento",
    saveWorkout: "Guardar entrenamiento",
    addExercise: "Añadir ejercicio",
    sets: "Series",
    reps: "Repeticiones",
    weight: "Peso",
    notes: "Notas",
    rest: "Descanso",
    noExercises: "Aún no hay ejercicios añadidos",
    duration: "Duración",
    calories: "Calorías",
    description: "Descripción",
    private: "Privado",
    public: "Público",
    trackDuration: "Registrar duración",
    manualDuration: "Duración manual",
    exercisePlaceholder: "Añade tu primer ejercicio para comenzar",
    saveAsTemplate: "Guardar como plantilla",
    loadTemplate: "Cargar plantilla",
    doAgain: "Repetir",
    analyze: "Análisis IA",
    deleteConfirm: "¿Eliminar entrenamiento?",
    deleteConfirmDescription: "Esta acción no se puede deshacer.",
    kg: "kg",
    lbs: "lbs",
    minutes: "minutos",
    hours: "horas",
    seconds: "segundos",
    set: "Serie",
    exercise: "Ejercicio",
    exercises: "Ejercicios",
    completed: "Completado",
    inProgress: "En progreso",
    paused: "Pausado",
    resume: "Reanudar",
    pause: "Pausar",
    stop: "Detener",
    restTimer: "Temporizador de descanso",
    skipRest: "Saltar descanso",
    addSet: "Añadir serie",
    removeSet: "Eliminar serie",
    superset: "Superserie",
    createSuperset: "Crear superserie",
    personalRecord: "Récord personal",
    newPR: "¡Nuevo PR!",
    previousBest: "Mejor anterior",
    selectExercise: "Seleccionar ejercicio",
    searchExercises: "Buscar ejercicios...",
    recentExercises: "Ejercicios recientes",
    allExercises: "Todos los ejercicios",
    customExercise: "Ejercicio personalizado",
    addCustomExercise: "Añadir ejercicio personalizado",
    targetMuscles: "Músculos objetivo",
    techniqueTips: "Consejos de técnica",
    commonMistakes: "Errores comunes",
    history: "Historial",
    noHistory: "No hay historial disponible",
    tagFriends: "Etiquetar amigos",
    shareWorkout: "Compartir entrenamiento",
    copyWorkout: "Copiar entrenamiento",
    workoutComplete: "¡Entrenamiento completo!",
    greatJob: "¡Buen trabajo!",
    summary: "Resumen",
    totalVolume: "Volumen total",
    totalSets: "Series totales",
    totalReps: "Repeticiones totales",
  },
  dashboard: {
    title: "Panel",
    welcome: "Bienvenido de nuevo",
    todayWorkout: "Entrenamiento de hoy",
    weeklyProgress: "Progreso semanal",
    recentActivity: "Actividad reciente",
    quickActions: "Acciones rápidas",
    noWorkouts: "Aún no hay entrenamientos",
    startFirst: "¡Comienza tu primer entrenamiento!",
    pullToRefresh: "Desliza para actualizar",
    loadMore: "Cargar más",
    communityFeed: "Feed de la comunidad",
    yourFeed: "Tu feed",
    announcements: "Anuncios",
    noActivity: "Sin actividad reciente",
    startWorking: "¡Comienza a entrenar para ver tu progreso aquí!",
    streak: "Racha",
    days: "días",
    thisWeek: "Esta semana",
    personalRecords: "Récords personales",
    weeklyGoal: "Objetivo semanal",
    workoutsThisWeek: "entrenamientos esta semana",
    activity: "Actividad",
    upgradeToPremium: "Mejora a Premium",
    unlockFeatures: "Desbloquea estadísticas, clasificación y análisis",
    beFirstToLog: "¡Sé el primero en registrar un entrenamiento y compartir con la comunidad!",
    logFirstWorkout: "Registra tu primer entrenamiento",
    doLiveWorkout: "Iniciar entrenamiento en vivo",
    editWorkout: "Editar entrenamiento",
    moreExercises: "más",
    showLess: "Ver menos",
    aiWorkoutAnalysis: "Análisis de entrenamiento con IA",
    aiAnalysisDescription: "Obtén información impulsada por IA sobre rendimiento, consejos de forma y sugerencias de mejora. Función Premium.",
    loadingMore: "Cargando más entrenamientos...",
    endOfFeed: "Has llegado al final del feed",
    workoutTitle: "Título del entrenamiento",
    workoutTitlePlaceholder: "Mi increíble entrenamiento",
    descriptionPlaceholder: "Describe tu entrenamiento...",
    saveChanges: "Guardar cambios",
    withFriends: "con amigos",
  },
  profile: {
    title: "Perfil",
    editProfile: "Editar perfil",
    followers: "Seguidores",
    following: "Siguiendo",
    workouts: "Entrenamientos",
    joined: "Se unió",
    yourGoals: "Tus objetivos",
    fitnessGoal: "Objetivo fitness",
    experienceLevel: "Nivel de experiencia",
    weeklyCheckIn: "Check-in semanal",
    workoutHistory: "Historial de entrenamientos",
    checkIns: "Check-ins",
    upgradePremium: "Mejora a Premium",
    unlockFeatures: "Desbloquea estadísticas, clasificación y análisis",
    viewPlans: "Ver planes",
    bio: "Biografía",
    fullName: "Nombre completo",
    dateOfBirth: "Fecha de nacimiento",
    height: "Altura",
    currentWeight: "Peso actual",
    gender: "Género",
    male: "Masculino",
    female: "Femenino",
    other: "Otro",
    preferNotToSay: "Prefiero no decir",
    saveChanges: "Guardar cambios",
    noGoalsSet: "Sin objetivos establecidos aún",
    setGoals: "Establece tus objetivos de fitness",
    memberSince: "Miembro desde",
    totalWorkouts: "Entrenamientos totales",
    currentStreak: "Racha actual",
    longestStreak: "Racha más larga",
    verified: "Verificado",
    statisticsReset: "Estadísticas restablecidas",
    statisticsResetDesc: "Todas tus estadísticas han sido restablecidas exitosamente",
    resetFailed: "Error al restablecer",
    goalsUpdated: "Objetivos actualizados",
    goalsUpdatedDesc: "Tus objetivos de fitness han sido actualizados",
    goals: {
      buildMuscle: "Desarrollar músculo",
      loseWeight: "Perder peso",
      getStronger: "Hacerse más fuerte",
      improveEndurance: "Mejorar resistencia",
      stayActive: "Mantenerse activo",
      athleticPerformance: "Rendimiento atlético",
    },
  },
  achievements: {
    title: "Logros",
    unlocked: "Desbloqueado",
    locked: "Bloqueado",
    progress: "Progreso",
    keepGoing: "¡Sigue así!",
    newUnlock: "¡Nuevo logro desbloqueado!",
    milestone: "Hito",
    strength: "Fuerza",
    consistency: "Consistencia",
    social: "Social",
    variety: "Variedad",
    volume: "Volumen",
    all: "Todos",
    earned: "Obtenido",
    unearned: "Aún no obtenido",
    congratulations: "¡Felicitaciones!",
    youEarned: "Has obtenido",
    shareAchievement: "Compartir logro",
    viewAll: "Ver todos los logros",
    recentlyUnlocked: "Recientemente desbloqueados",
  },
  friends: {
    title: "Amigos",
    addFriend: "Añadir amigo",
    searchUsers: "Buscar usuarios...",
    pending: "Pendiente",
    accepted: "Amigos",
    noFriends: "Aún no hay amigos",
    sendRequest: "Enviar solicitud",
    acceptRequest: "Aceptar",
    declineRequest: "Rechazar",
    removeFriend: "Eliminar amigo",
    friendRequests: "Solicitudes de amistad",
    myFriends: "Mis amigos",
    suggestions: "Sugerencias",
    noRequests: "Sin solicitudes pendientes",
    requestSent: "¡Solicitud enviada!",
    requestAccepted: "¡Solicitud aceptada!",
    requestDeclined: "Solicitud rechazada",
    friendRemoved: "Amigo eliminado",
    mutualFriends: "amigos en común",
    viewProfile: "Ver perfil",
    message: "Mensaje",
  },
  premium: {
    title: "Premium",
    upgrade: "Mejorar",
    features: "Funciones Premium",
    monthly: "Mensual",
    yearly: "Anual",
    currentPlan: "Plan actual",
    subscribe: "Suscribirse",
    restore: "Restaurar compras",
    perMonth: "/mes",
    perYear: "/año",
    savePercent: "Ahorra",
    mostPopular: "Más popular",
    freePlan: "Plan gratuito",
    premiumPlan: "Plan Premium",
    includesFeatures: "Incluye todas las funciones",
    unlockAll: "Desbloquear todas las funciones",
    alreadyPremium: "¡Ya eres miembro premium!",
    manageSubscription: "Gestionar suscripción",
    cancelAnytime: "Cancela cuando quieras",
    startFreeTrial: "Iniciar prueba gratuita",
    trialDays: "días de prueba gratuita",
    bestValue: "Mejor valor",
    billedAnnually: "Facturado anualmente",
    billedMonthly: "Facturado mensualmente",
    featuresList: {
      analytics: "Estadísticas avanzadas e información",
      leaderboard: "Acceso a la clasificación de fitness",
      aiAnalysis: "Análisis de entrenamiento con IA",
      templates: "Plantillas ilimitadas",
      checkIns: "Check-ins semanales con fotos",
      exportData: "Exportar tus datos",
      prioritySupport: "Soporte prioritario",
      noAds: "Experiencia sin anuncios",
    },
  },
  templates: {
    title: "Plantillas",
    create: "Crear plantilla",
    edit: "Editar plantilla",
    delete: "Eliminar plantilla",
    myTemplates: "Mis plantillas",
    publicTemplates: "Plantillas públicas",
    noTemplates: "Aún no hay plantillas",
    createFirst: "Crea tu primera plantilla",
    templateName: "Nombre de plantilla",
    templateDescription: "Descripción",
    category: "Categoría",
    makePublic: "Hacer pública",
    publicDescription: "Permitir que otros usuarios premium vean y usen esta plantilla",
    addExercise: "Añadir ejercicio",
    saveTemplate: "Guardar plantilla",
    useTemplate: "Usar plantilla",
    startWorkout: "Iniciar entrenamiento",
    exercises: "ejercicios",
    createdBy: "Creado por",
    generateWithAI: "Generar con IA",
    aiPromptPlaceholder: "Describe el entrenamiento que quieres (ej. 'entrenamiento de fuerza de tren superior para principiantes')...",
    generating: "Generando...",
    categories: {
      all: "Todos",
      beginner: "Principiante",
      advanced: "Avanzado",
      strength: "Fuerza",
      hypertrophy: "Hipertrofia",
      endurance: "Resistencia",
      general: "General",
    },
  },
  analytics: {
    title: "Estadísticas",
    overview: "Resumen",
    volume: "Volumen",
    strength: "Fuerza",
    progression: "Progresión",
    calendar: "Calendario",
    period: "Período",
    week: "Semana",
    month: "Mes",
    year: "Año",
    totalWorkouts: "Entrenamientos totales",
    totalVolume: "Volumen total",
    avgVolume: "Volumen promedio",
    personalRecords: "Récords personales",
    muscleGroups: "Grupos musculares",
    volumeOverTime: "Volumen a lo largo del tiempo",
    strengthProgress: "Progreso de fuerza",
    workoutCalendar: "Calendario de entrenamientos",
    noData: "No hay datos disponibles",
    startTracking: "Comienza a registrar tus entrenamientos para ver estadísticas",
    comparedToPrevious: "comparado con el período anterior",
    improvement: "mejora",
    decline: "descenso",
    noChange: "sin cambios",
    exerciseTrends: "Tendencias de ejercicios",
    plateauDetection: "Detección de estancamiento",
    injuryRisk: "Evaluación de riesgo de lesiones",
    fitnessScore: "Puntuación de fitness",
    restDays: "Días de descanso",
    prRate: "Tasa de PR",
    bestDay: "Mejor día",
    volumeVelocity: "Velocidad de volumen",
    filters: {
      muscleGroup: "Grupo muscular",
      exerciseType: "Tipo de ejercicio",
      all: "Todos",
      chest: "Pecho",
      back: "Espalda",
      legs: "Piernas",
      shoulders: "Hombros",
      arms: "Brazos",
      cardio: "Cardio",
      strength: "Fuerza",
    },
  },
  notifications: {
    title: "Notificaciones",
    markAllRead: "Marcar todo como leído",
    deleteAll: "Eliminar todo",
    noNotifications: "Aún no hay notificaciones",
    preferences: "Preferencias de notificaciones",
    types: {
      like: "Me gusta",
      comment: "Comentario",
      friendRequest: "Solicitud de amistad",
      friendAccepted: "Amigo aceptado",
      personalRecord: "Récord personal",
      workoutTag: "Etiqueta de entrenamiento",
      announcement: "Anuncio",
    },
    settings: {
      likes: "Me gusta",
      likesDescription: "Cuando alguien le da me gusta a tu entrenamiento",
      comments: "Comentarios",
      commentsDescription: "Cuando alguien comenta en tu entrenamiento",
      friendRequests: "Solicitudes de amistad",
      friendRequestsDescription: "Cuando alguien te envía una solicitud de amistad",
      friendAccepted: "Amigo aceptado",
      friendAcceptedDescription: "Cuando alguien acepta tu solicitud de amistad",
      personalRecords: "Récords personales",
      personalRecordsDescription: "Cuando logras un nuevo récord personal",
      workoutTags: "Etiquetas de entrenamiento",
      workoutTagsDescription: "Cuando alguien te etiqueta en un entrenamiento",
    },
    deleteAllConfirm: "¿Eliminar todas las notificaciones?",
    deleteAllDescription: "Esto eliminará permanentemente todas las notificaciones. Esta acción no se puede deshacer.",
    allMarkedRead: "Todas las notificaciones marcadas como leídas",
    allDeleted: "Todas las notificaciones eliminadas",
  },
  support: {
    title: "Centro de soporte",
    contactUs: "Contáctanos",
    contactDescription: "¿Necesitas ayuda? Nuestro equipo de soporte está aquí para ti.",
    emailSupport: "Soporte por correo",
    responseTime: "Normalmente respondemos en 24 horas",
    submitTicket: "Enviar ticket de soporte",
    faq: "FAQ",
    frequentlyAsked: "Preguntas frecuentes",
    privacyPolicy: "Política de privacidad",
    privacyDescription: "Conoce cómo protegemos y manejamos tus datos",
    accountDeletion: "Eliminación de cuenta",
    accountDeletionDescription: "Instrucciones para eliminar permanentemente tu cuenta",
    goToSettings: "Ir a configuración",
    faqs: {
      cancelSubscription: {
        question: "¿Cómo cancelo mi suscripción?",
        answer: "Puedes gestionar tu suscripción a través de la configuración de tu cuenta. Para suscripciones web, usa el portal del cliente. Para suscripciones iOS, ve a Ajustes > [Tu nombre] > Suscripciones en tu iPhone.",
      },
      deleteAccount: {
        question: "¿Cómo elimino mi cuenta?",
        answer: "Puedes eliminar tu cuenta desde el diálogo de Configuración en la app. Esto eliminará permanentemente todos tus datos, incluyendo entrenamientos, fotos de progreso y récords personales.",
      },
      dataAfterDeletion: {
        question: "¿Qué pasa con mis datos después de eliminar la cuenta?",
        answer: "Todos tus datos se eliminan permanentemente de nuestros servidores, incluyendo entrenamientos, fotos, logros e información personal. Esta acción no se puede deshacer.",
      },
      restorePurchase: {
        question: "¿Cómo restauro mi compra de Apple In-App?",
        answer: "Ve a la página Premium en la app y toca el botón 'Restaurar compras'. Asegúrate de haber iniciado sesión con el mismo Apple ID usado para la compra original.",
      },
      exportData: {
        question: "¿Puedo exportar mis datos de entrenamiento?",
        answer: "Los usuarios Premium pueden exportar su historial de entrenamientos desde la página de Estadísticas. Los usuarios gratuitos pueden contactar soporte para solicitudes de exportación de datos.",
      },
    },
  },
  leaderboard: {
    title: "Clasificación",
    rank: "Posición",
    user: "Usuario",
    score: "Puntuación",
    fitnessScore: "Puntuación de fitness",
    weeklyVolume: "Volumen semanal",
    monthlyWorkouts: "Entrenamientos mensuales",
    totalPRs: "PRs totales",
    yourRank: "Tu posición",
    top10: "Top 10",
    friends: "Amigos",
    friendsRanking: "Ranking de amigos",
    global: "Global",
    globalRanking: "Ranking Global",
    noData: "No hay datos de clasificación disponibles",
    period: "Período",
    metric: "Métrica",
  },
  time: {
    justNow: "Ahora mismo",
    minutesAgo: "m atrás",
    hoursAgo: "h atrás",
    daysAgo: "d atrás",
    weeksAgo: "sem atrás",
    monthsAgo: "mes atrás",
    yearsAgo: "año atrás",
    today: "Hoy",
    yesterday: "Ayer",
    thisWeek: "Esta semana",
    lastWeek: "Semana pasada",
    thisMonth: "Este mes",
    lastMonth: "Mes pasado",
  },
  errors: {
    somethingWentWrong: "Algo salió mal",
    tryAgain: "Por favor, inténtalo de nuevo",
    networkError: "Error de red. Por favor, verifica tu conexión.",
    notFound: "No encontrado",
    unauthorized: "No tienes autorización para realizar esta acción",
    forbidden: "Acceso prohibido",
    serverError: "Error del servidor. Por favor, inténtalo más tarde.",
    validationError: "Error de validación",
    requiredField: "Este campo es obligatorio",
    invalidEmail: "Por favor, introduce una dirección de correo válida",
    invalidPassword: "La contraseña no cumple los requisitos",
    passwordTooShort: "La contraseña debe tener al menos 12 caracteres",
    usernameTaken: "Este nombre de usuario ya está en uso",
    emailTaken: "Este correo ya está registrado",
    invalidCredentials: "Correo o contraseña inválidos",
    sessionExpired: "Tu sesión ha expirado. Por favor, inicia sesión de nuevo.",
    rateLimited: "Demasiados intentos. Por favor, inténtalo más tarde.",
    serviceUnavailable: "Servicio temporalmente no disponible. Por favor, inténtalo en un momento.",
  },
  landing: {
    hero: "Registra tu viaje fitness",
    tagline: "El compañero de entrenamiento definitivo para registrar progreso, conectar con amigos y alcanzar tus objetivos de fitness.",
    getStarted: "Comenzar",
    learnMore: "Saber más",
    features: {
      trackProgress: {
        title: "Registra tu progreso",
        description: "Registra entrenamientos, sigue récords personales y visualiza tu mejora a lo largo del tiempo.",
      },
      socialFeed: {
        title: "Feed social",
        description: "Comparte logros, anima a tus amigos y mantente motivado juntos.",
      },
      achieveGoals: {
        title: "Alcanza objetivos",
        description: "Establece metas de fitness, desbloquea logros y celebra cada hito.",
      },
    },
  },
};
